import { request, requestFormData } from './client';
import type {
  ThreadAccountPostReservation,
  ThreadAccountPostReservationCreateRequest,
  ThreadAccountPostReservationDraftUpdateRequest,
  ThreadPostCreateResponse,
} from './types';

export function listReservations(
  threadAccountId: number,
  pendingOnly = false
) {
  const q = pendingOnly ? '?pendingOnly=true' : '';
  return request<ThreadAccountPostReservation[]>(
    `/api/thread-account-post-reservations/thread-account/${threadAccountId}${q}`,
    { method: 'GET' }
  );
}

export function createReservation(
  threadAccountId: number,
  payload: ThreadAccountPostReservationCreateRequest
) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/thread-account/${threadAccountId}`,
    { method: 'POST', body: payload }
  );
}

export function deleteReservation(id: number) {
  return request<string>(
    `/api/thread-account-post-reservations/id/${id}`,
    { method: 'DELETE' }
  );
}

export function deleteFailedReservations(threadAccountId: number) {
  return request<number>(
    `/api/thread-account-post-reservations/thread-account/${threadAccountId}/failed`,
    { method: 'DELETE' }
  );
}

export function cancelReservation(id: number) {
  return request<string>(
    `/api/thread-account-post-reservations/id/${id}/cancel`,
    { method: 'POST' }
  );
}

export function retryReservation(id: number) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/retry`,
    { method: 'POST' }
  );
}

/** AI 초안 제작 (발행 없음) */
export function prepareReservation(id: number) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/prepare`,
    { method: 'POST' }
  );
}

/** 초안 수정 */
export function updateReservationDraft(
  id: number,
  payload: ThreadAccountPostReservationDraftUpdateRequest
) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/draft`,
    { method: 'PUT', body: payload }
  );
}

/** 초안 즉시 발송 */
export function publishReservation(id: number) {
  return request<ThreadPostCreateResponse>(
    `/api/thread-account-post-reservations/id/${id}/publish`,
    { method: 'POST' }
  );
}

export function approveReservation(id: number) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/approve`,
    { method: 'POST' }
  );
}

export function reconcileReservation(id: number, threadPostId: string) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/reconcile`,
    { method: 'POST', body: { threadPostId } }
  );
}

/** 초안에 사진 업로드 (발송 이미지로 지정) */
export function uploadReservationDraftImage(
  id: number,
  file: File,
  followUp = false
) {
  const formData = new FormData();
  formData.append('file', file);
  const q = followUp ? '?followUp=true' : '';
  return requestFormData<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/draft/image${q}`,
    formData
  );
}

export function startReservation(id: number) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/start`,
    { method: 'POST' }
  );
}

export function completeReservation(id: number) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/complete`,
    { method: 'POST' }
  );
}

export function failReservation(id: number, message?: string) {
  return request<ThreadAccountPostReservation>(
    `/api/thread-account-post-reservations/id/${id}/fail`,
    { method: 'POST', body: { message: message ?? null } }
  );
}
